import * as React from 'react';
import { IButtonProps } from './IButton';

const Button = (props: IButtonProps) => {
    const [btdisabled, setBtDisabled] = React.useState<boolean>(false);

    const handleClick = () => {
        setBtDisabled(true);

        return new Promise<boolean>(resolve => {
            setTimeout(() => {
                resolve(false);
            }, 150);
        });
    };

    return (
        <div className={props.className}>
            <button
                type={props.type || 'button'}
                className={props.classNameBtn}
                disabled={btdisabled || props.disabled}
                onClick={e =>
                    handleClick()
                        .then((res: boolean) => {
                            setBtDisabled(res);
                            props.onClick ? props.onClick(e) : null;
                        })
                        .catch(() => {
                            setBtDisabled(false);
                        })
                }>
                {props.children}
            </button>
        </div>
    );
};

export default Button;
